module.exports = __webpack_public_path__ + "img/confirm-demo-th.be2a5a4.png";